import request from '@/router/axios'
import env from '@/config/env'

// 保存批次
export function save(data) {
  return request({
    url: env.ferryUrl + '/couponBatch/saveBatch',
    method: 'post',
    data
  })
}

// 供应商不分页
export function getMerchantList() {
  return request({
    url: env.ferryUrl + '/couponBatch/getMerchantList',
    method: 'post'
  })
}

// 供应商分页
export function getMerchantListPage(data) {
  return request({
    url: env.ferryUrl + '/couponBatch/getMerchantPage',
    method: 'post',
    data
  })
}

// 批次列表
export function list(data) {
  return request({
    url: env.ferryUrl + '/couponBatch/page',
    method: 'post',
    data
  })
}

// 创建礼包
export function pkgCreate(data) {
  return request({
    url: env.ferryUrl + '/couponBatch/saveGift',
    method: 'post',
    data
  })
}

/**
 * 根据批次ID获取礼包详情
 * @param id
 */
export function getPkgDetails(id) {
  return request({
    url: env.ferryUrl + `/couponBatch/getBatchInfo/${id}`,
    method: 'post'
  })
}

// 根据礼包id获取优惠券详情
export function getCPkgDetails(id) {
  return request({
    url: env.ferryUrl + `/couponBatch/getGiftInfo/${id}`,
    method: 'post'
  })
}

// 批次详情礼包分页
export function listGiftPageByBatchId(data) {
  return request({
    url: env.ferryUrl + '/couponBatch/getGiftBagPage',
    method: 'post',
    data
  })
}

// 批次详情优惠券分页
export function listCouponPageByGiftId(data) {
  return request({
    url: env.ferryUrl + '/couponBatch/getCouponPage',
    method: 'post',
    data
  })
}

// 增发礼包数量
export function addPkgNum(data) {
  return request({
    url: env.ferryUrl + '/couponBatch/addGiftBag',
    method: 'post',
    data
  })
}

// 通过供应商查询线路
export function getLineByMerchant(merchantId) {
  return request({
    url: env.ferryUrl + `/couponBatch/getLine/${merchantId}`,
    method: 'post'
  })
}

// 添加优惠券
export function addCoupon(data) {
  return request({
    url: env.ferryUrl + '/couponBatch/saveCoupon',
    method: 'post',
    data
  })
}

// 获取优惠券详情
export function getCouponDetailsById(id) {
  return request({
    url: env.ferryUrl + `/couponBatch/getCouponInfo/${id}`,
    method: 'post'
  })
}

// 作废
export function zuofei(id) {
  return request({
    url: env.ferryUrl + `/couponBatch/invalidCoupon/${id}`,
    method: 'post'
  })
}

// 增发优惠券
export function newAddCoupons(data) {
  return request({
    url: env.ferryUrl + '/couponBatch/addCoupon',
    method: 'post',
    data
  })
}

// 获取优惠券详情数据那个
export function getCouponDetailsDataById(id) {
  return request({
    url: env.ferryUrl + `/couponBatch/getCouponData/${id}`,
    method: 'post'
  })
}

// 查询详情数据
export function getCouponDetailsDataPage(data) {
  return request({
    url: env.ferryUrl + '/couponBatch/getPageCouponData',
    method: 'POST',
    data
  })
}

// 作废批次
export function zuofeipici(id) {
  return request({
    url: env.ferryUrl + `/couponBatch/invalidBatch/${id}`,
    method: 'post'
  })
}

// 作废礼包
export function zuofeilibao(id) {
  return request({
    url: env.ferryUrl + `/couponBatch/invalidGift/${id}`,
    method: 'post'
  })
}

// 获取节假日
export function getHolidayConfig(id) {
  return request({
    url: env.ferryUrl + '/couponBatch/holidays-all',
    method: 'get'
  })
}
